var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.62305 15.4834V9.44531",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.62402 4.08226V1.53906",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.62334 9.43643C5.07217 9.43643 6.24667 8.23693 6.24667 6.75728C6.24667 5.27762 5.07217 4.07812 3.62334 4.07812C2.17451 4.07812 1 5.27762 1 6.75728C1 8.23693 2.17451 9.43643 3.62334 9.43643Z",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.376 7.57715V1.53906",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.376 15.4885V12.9453",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.3763 12.9364C12.8251 12.9364 13.9996 11.7369 13.9996 10.2573C13.9996 8.77762 12.8251 7.57812 11.3763 7.57812C9.92744 7.57812 8.75293 8.77762 8.75293 10.2573C8.75293 11.7369 9.92744 12.9364 11.3763 12.9364Z",
    stroke: "#333333",
    strokeWidth: 1.61445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.cf835491ea5d29b6b75008062a6c600f.svg";
export { ForwardRef as ReactComponent };